import { FilterItemAdditionalProps } from "./FilterItemAdditionalProps";
import {
    isKmsTypeFilterItemRadio,
    isKmsTypeFilterItemGroup,
    isKmsTypeFilterItemDropdown,
    isKmsTypeFilterItemCheckbox,
    isKmsTypeFilterItemRange,
    SupportedKmsTypeFilterItem,
} from "@kaltura/mediaspace-shared-types";
import { CheckboxFilterItem } from "./CheckboxFilterItem";
import { RadioFilterItem } from "./RadioFilterItem";
import { FreeTextFilterItem } from "./FreeTextFilterItem";
import { GroupFilterItem } from "./GroupFilterItem";
import DateFilterItem from "./DateFilterItem";
import RangeFilterItem from "./RangeFilterItem";

/**
 * filter item - a filter item factory
 */
export function FilterItem<T extends SupportedKmsTypeFilterItem>(props: T & FilterItemAdditionalProps) {
    if (isKmsTypeFilterItemGroup(props)) {
        return <GroupFilterItem {...props} />;
    }

    if (isKmsTypeFilterItemCheckbox(props)) {
        return <CheckboxFilterItem {...props} />;
    }

    if (isKmsTypeFilterItemRadio(props)) {
        return <RadioFilterItem {...props} />;
    }

    if (isKmsTypeFilterItemDropdown(props)) {
        return <RadioFilterItem {...props} radioButton={true} />;
    }

    if ("freeText" in props && props.freeText) {
        return <FreeTextFilterItem {...props} />;
    }

    if ("datepicker" in props && props.datepicker) {
        return <DateFilterItem {...props} />;
    }
    if (isKmsTypeFilterItemRange(props)) {
        return <RangeFilterItem {...props} />;
    }

    return <></>;
}

export default FilterItem;
